const HONEYPOT_FIELD_NAME = "fax";
const LOCATION_FIELD_NAME = "location";
const POSTAL_CODE_FIELD_NAME = "postalCode";
const TIMING_TOKEN_FIELD_NAME = "formTimingToken";

const POSTAL_FIELD_NAMES = new Set([
  LOCATION_FIELD_NAME,
  POSTAL_CODE_FIELD_NAME,
]);

export {
  HONEYPOT_FIELD_NAME,
  LOCATION_FIELD_NAME,
  POSTAL_CODE_FIELD_NAME,
  POSTAL_FIELD_NAMES,
  TIMING_TOKEN_FIELD_NAME,
};
